export default class DisclosedMetricRule {
    isSupport(filters, node) {
        if(filters.metric_name === 'is_disclosed'){
            for (const value of filters.disclosed_filter) {
                if(value === 'disclosed' && node.data.attributes.is_disclosed ){
                    if(node.children){
                        let isAllChildrenDisclosed = true;
                        for (const child of node.children) {
                            if(!child.data.attributes.is_disclosed){
                                isAllChildrenDisclosed = false;
                            }
                        }
                        return isAllChildrenDisclosed;
                    } else {
                        return true
                    }
                }
            }
        }
        return false
    }
    getColor() {
        return '#03A233';
    }
    getTextColor(filters, node) {
        if (filters.vendor_name === node.data?.attributes.vendor_name){
            return '#2D2D2D';
        } else {
            return '#FFFFFF';
        }
    }
    getNodeBackgroundColor(filters, node) {
        if (filters.vendor_name === node.data?.attributes.vendor_name){
            return '#41ff6d';
        } else {
            return '#03A233';
        }
    }
    getOpacity() {
        return 1;
    }
}
